export enum AppRoute {
  CCB = '/finance/creditcardcc',
  Chargeback = '/finance/creditcardcc',
  Details = '/finance/creditcardcc/:category/:transactionId',
  checkSearch = '/finance/returncheck',
  checkDetails = '/finance/returncheck/:category/:transactionId',
}
